import React from "react";
import {withRouter} from "react-router";
import {Card, CardContent} from "@material-ui/core";
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';
import APPCONFIG from "../../constants/Config";
import {Button} from "reactstrap";
import API from "@beardeddevops/react.api";

export default class AltrupaySpinProcessor extends Framework.Components.Object {

	constructor(props) {
		/**
		 * @typedef {Terminals_Altrupay_Object} this.state
		 */
		super(props, Types.Terminals_Altrupay._name);
		//this.noDelete = false;
	}

	afterSubmit = () => {
		//reload the tab
		this.props.history.push('/');
		this.props.history.push('/settings#altrupay');
	}

	form = () => {
		/** @type {Terminals_Altrupay_Properties} */
		let {properties} = this.model;
		/** @type {Terminals_Altrupay_Object} */
		let object = this.state;
		return (
			<Card>
				<CardContent>
					<div className={'row'}>
						<div className={'col-4'}>
							<div className={'form-group'}>
								<Framework.Elements.TextField
									label={"TPN Code"}
									property={properties.tpn}
									value={object.tpn}
									error={object.tpn_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={'col-4'}>
							<div className={'form-group'}>
								<Framework.Elements.TextField
									label={"Auth Key"}
									property={properties.authkey}
									value={object.authkey}
									error={object.authkey_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
						<div className={'col-4'}>
							<div className={'form-group'}>
								<Framework.Elements.TextField
									label={"Terminal Nickname"}
									property={properties.nickname}
									value={object.nickname}
									error={object.nickname_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
				</CardContent>
			</Card>
		)
	}
}
